import { Extension } from '@tiptap/core';

export const IsFocused = Extension.create({
   name: 'isFocused',

   addStorage() {
      return {
         isFocused: false,
      };
   },

   onFocus() {
      this.storage.isFocused = true;
   },

   onBlur() {
      this.storage.isFocused = false;
   },
});
